import { useEffect, useMemo } from 'react'
import { Box } from '@material-ui/core'
import { useField } from 'react-final-form'

import Textfield from '../../../control/textfield/textfield'
import RichTextEditor2, { InitialRichTextEditorType } from '../../../control/richTextEditor/richTextEditor2'
import useTranslate from '../../../i18n/useTranslate'

import type { ChecklistAnswerComment } from '../../../services/web/useChecklist'

export interface AnswerCommentProps {
    name: string
    initialValues: any
    answers: ChecklistAnswerComment[]
    disabled?: boolean
}

function AnswerComment(props: AnswerCommentProps) {
    const translate = useTranslate()
    const { name, initialValues, answers, disabled } = props
    //const { input } = useField<string>(name, { initialValue: '' })

    const selected = answers.find((a) => a.checked)
    const requiresComment = selected ? selected.isDefault === false : false

    const valueMessageTH = useMemo<InitialRichTextEditorType>(
        () => ({ contentHtml: initialValues?.contentHtml, contentText: initialValues?.contentText }),
        []
    )

    return (
        <Box pl={2} style={{ display: requiresComment ? 'block' : 'none' }}>
            <RichTextEditor2
                name={name}
                initialRichTextEditor={valueMessageTH}
                disabled={false}
                label={''}
                placeholder={''}
                required={false}
                isHideToolbar={false}
            />
            {/* <Textfield
                name={name}
                materialInputProps={{
                    label: 'ความคิดเห็น',
                    placeholder: 'กรอกความคิดเห็น',
                    size: 'small',
                    rows: 2,
                    multiline: true,
                    disabled: disabled,
                }}
                maxLength={1000}
            /> */}
        </Box>
    )
}
export default AnswerComment
